import { Component } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { HostBinding } from '@angular/core';
import { HostListener } from '@angular/core';
import { Input } from '@angular/core';
import { Output } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ui-radio',
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None
})
export class UIRadioComponent {

    @HostBinding('attr.disabled')
    @Input()
    disabled: boolean;

    @Input()
    value: any;

    @HostBinding('class.checked')
    checked: boolean;

    @Output()
    onCheckRadio = new EventEmitter<UIRadioComponent>();

    @HostListener('click')
    private _onClick() {
        this._toggle();

    }

    @HostListener('keydown.space')
    private _onSpaceDown(): void {
        this._toggle();
    }

    @HostListener('keydown.spacebar')
    private _onSpacebarDown(): void {
        this._toggle();
    }

    private _toggle() {
        if (this.disabled === undefined) {
            this.onCheckRadio.emit(this);
        }
    }

}